/* ==========================================================================
   hero.js — wires the page to the catalogue
   --------------------------------------------------------------------------
   Everything on the page that is a fact about the products is written from
   here: the colourway count in the hero, and the accent colour the whole page
   is tinted with.

   It used to build two more things — a list of the three types in the header,
   and a grid of comparison cards for an act of their own. Both are gone. The
   reel names the three types at the head of its own column and switches
   between them there, so the page now offers that choice once instead of
   three times.

   Shared by the Liquid sections and the local dev preview, so the two cannot
   drift apart.
   ========================================================================== */

(function () {
  'use strict';

  function rgb(hex) {
    var v = parseInt(hex.slice(1), 16);
    return [(v >> 16) & 255, (v >> 8) & 255, v & 255];
  }

  /* The accent has to carry a word set in 6rem display type against porcelain,
     and to tint the reel's wash behind cut-out photography. Blacks vanish into
     the ink, whites and greys vanish into the ground, so the pool is filtered
     on both brightness and saturation before picking. */
  function usableAsAccent(hex) {
    var c = rgb(hex);
    var brightness = (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) / 255;
    var max = Math.max(c[0], c[1], c[2]);
    var min = Math.min(c[0], c[1], c[2]);
    var sat = max === 0 ? 0 : (max - min) / max;
    return brightness > 0.16 && brightness < 0.72 && sat > 0.22;
  }

  window.AriesHero = {
    init: function (catalog) {
      /* --- the page's accent ------------------------------------------- */
      var pool = [];
      catalog.models.forEach(function (m) {
        m.colorways.forEach(function (c) {
          if (usableAsAccent(c.shell.hex)) pool.push(c);
        });
      });

      if (pool.length) {
        // A different finish on every visit. The catalogue is the palette, so
        // the page should not settle on one brand colour and pretend the other
        // eighty do not exist.
        var pick = pool[Math.floor(Math.random() * pool.length)];
        document.documentElement.style.setProperty('--curl', pick.shell.hex);
        // Kept separately so the page can come back to it after the reel has
        // borrowed the accent for whichever finish was on screen.
        document.documentElement.style.setProperty('--curl-hero', pick.shell.hex);
      }

      var total = catalog.models.reduce(function (s, m) { return s + m.count; }, 0);
      Array.prototype.forEach.call(
        document.querySelectorAll('[data-colorway-count]'),
        function (el) { el.textContent = total; }
      );

      /* Nothing here creates an element any more, so there is nothing for the
         scroll reveals to rescan and no announcement to make. The counts above
         are written into markup that was already on the page. */
    },
  };
})();
